module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA_CHEMIA.a596056f.svg";